import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Header from "../../layout/header/header";

const FullBlogPage = () => {
  const location = useLocation();

  const [blogObj, setBlogObj] = useState({
    date: "1640105000213",
    author: "Authorname",
    title: "Ac servicing",
    image:
      "https://images.pexels.com/photos/615326/water-tap-black-and-white-macro-615326.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    type: "Service",
    content:
      "One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought. It wasn't a dream. His room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops",
    id: "6p6bdAuqZtm0QGU77Ed0",
  });

  useEffect(() => {
    if (location.state && location.state.blogData) {
      console.log("LOCATION: ", location.state.blogData);
      setBlogObj(location.state.blogData);
    }
  }, [location]);

  const formatAMPM = (date) => {
    var day = date.getDate();
    var month = date.getMonth();
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = `${day}/${month}/${year} ${hours} : ${minutes} ${ampm}`;
    return strTime;
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 768);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <div>
      <Header />
      <section className="best_offer" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <h2>{blogObj && blogObj.title ? blogObj.title : ""}</h2>
          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {isMobile ? (
              <div>
                <div className="col-12">
                  <div className="blogs_inner">
                    <img
                      className="img-fluid"
                      src={blogObj?.image}
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        height: "fit-content",
                      }}
                      alt="img"
                    />
                  </div>
                  <div
                    className="p-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p>
                      <b>by {blogObj?.author}</b>
                    </p>
                    <p>
                      <b>{formatAMPM(new Date(parseInt(blogObj?.date)))}</b>
                    </p>{" "}
                  </div>
                  <p className="p-2">{blogObj?.content}</p>
                </div>
              </div>
            ) : (
              <>
                <div className="col-6">
                  <div className="blogs_inner">
                    <img
                      className="img-fluid"
                      src={blogObj?.image}
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        height: "fit-content",
                      }}
                      alt="img"
                    />
                  </div>
                  <div
                    className="p-2"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <p>
                      <b>by {blogObj?.author}</b>
                    </p>
                    <p>
                      <b>{formatAMPM(new Date(parseInt(blogObj.date)))}</b>
                    </p>{" "}
                  </div>
                  <p className="p-2">{blogObj?.content}</p>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FullBlogPage;
